import React from 'react';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

import Translations from '../../../../assets/locale/en/content.json';
import { TngGrid, TngTypography } from '../../../../components/common';
import { OrderHistoryFilter } from '../../modals/OrderHistoryFilter';

interface PODatesProps {
  filterObj: OrderHistoryFilter;
  setFiltersObj: React.Dispatch<React.SetStateAction<OrderHistoryFilter>>;
}

const PODates: React.FC<PODatesProps> = ({ filterObj, setFiltersObj }) => {
  // update state after user update in poDate fields
  const handlePoDateChange = (key: string) => (event: Dayjs | null) => {
    const formattedDate = event;
    if (dayjs(formattedDate, 'YYYY-MM-DD', true).isValid()) {
      setFiltersObj({ ...filterObj, [key]: formattedDate });
    } else {
      setFiltersObj({ ...filterObj, [key]: null });
    }
  };

  return (
    <TngGrid container marginTop="20px">
      <TngGrid item xs={12} className="order_status_text">
        <TngTypography variant="h5" id="po-date-range-label">
          {Translations.filterSection.poDateRange}
        </TngTypography>
      </TngGrid>
      <TngGrid item xs={12} sm={12} md={12} lg={6} className="po_date_range">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterObj.poDateFrom}
            onChange={handlePoDateChange('poDateFrom')}
            format="YYYY-MM-DD"
            slotProps={{
              textField: {
                inputProps: {
                  'aria-label': `${Translations.filterSection.poDateRange} from`,
                },
              },
            }}
          />
        </LocalizationProvider>
      </TngGrid>
      <TngGrid item xs={12} sm={12} md={12} lg={6} className="po_date_range" textAlign="right">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterObj.poDateTo}
            onChange={handlePoDateChange('poDateTo')}
            format="YYYY-MM-DD"
            slotProps={{
              textField: {
                inputProps: {
                  'aria-label': `${Translations.filterSection.poDateRange} to`,
                },
              },
            }}
          />
        </LocalizationProvider>
      </TngGrid>
    </TngGrid>
  );
};

export default PODates;
